
import isLocationInList from '../helpers/Advert/Geolocation';

const AdTypes = {
  Media: 'Media',
  Overlay: 'Overlay',
};

const Advert = {

  padd: n => {
    return `${(n < 10 ? '0' : '')}${n}`;
  },

  secondsToHMS: seconds => {
    const h = Math.floor( seconds / 3600);
    const m = Math.floor( seconds % 3600 / 60);
    const s = seconds % 60;
    return `${Advert.padd(h)}:${Advert.padd(m)}:${Advert.padd(s)}`;
  },

  getRollStartDateTime: roll => {
    return new Date(`${roll.startDateRestriction}T${roll.startTimeRestriction || '00:00:00'}`);   // REVIEW mejorar la opcionalidad
  },

  getRollEndDateTime: roll => {
    return new Date(`${roll.endDateRestriction}T${roll.endTimeRestriction || '23:59:59'}`);   // REVIEW mejorar la opcionalidad
  },

  selectMatchingRoll: (rolls = []) => {
    const now = Date.now();
    const defaultRoll = rolls.find( roll => roll.default);
    const rollsMatchingDate = rolls
      .filter( roll => !roll.startDateRestriction || Advert.getRollStartDateTime( roll) <= now)
      .filter( roll => !roll.endDateRestriction || now <= Advert.getRollEndDateTime( roll));
    const rollsMatching = rollsMatchingDate.filter( roll => !roll.countryRestriction || isLocationInList([ roll.countryRestriction ]));

    if( rollsMatching && rollsMatching.length) return rollsMatching[ Math.round(Math.random() * (rollsMatching.length - 1)) ];
    return defaultRoll;
  },

  generateMediaVastData: (media, skipoffset) => {
    const mediaFiles = media.bitrates.map( (mediaBitrate, i) => (
      `<MediaFile id="${i}" bitrate="${mediaBitrate.bitrate}" type="video/mp4" delivery="progressive">
        https:${mediaBitrate.url}
      </MediaFile>`
    )).join('\n');

    return `
      <VAST version="3.0">
        <Ad id="${media.id}">
          <InLine>
            <AdSystem>Static VAST Template</AdSystem>
            <AdTitle>${media.title}</AdTitle>
            ${(media.description) ? `<Description>${media.description}</Description>` : ''}
            <Creatives>
              <Creative>
                <Linear ${(skipoffset) ? `skipoffset="${Advert.secondsToHMS(skipoffset)}"` : ''}>
                  <Duration>${Advert.secondsToHMS(media.duration)}</Duration>
                  <MediaFiles>
                    ${mediaFiles}
                  </MediaFiles>
                </Linear>
              </Creative>
            </Creatives>
          </InLine>
        </Ad>
      </VAST>
    `;
  },

  generateOverlayVastData: overlay => {
    return `
      <VAST version="3.0">
        <Ad id="${overlay.id}">
          <InLine>
            <AdSystem>Static VAST Template</AdSystem>
            <AdTitle>Static Overlay VAST Template</AdTitle>
            <Creatives>
              <Creative>
                <NonLinearAds>
                  <NonLinear>
                    <StaticResource creativeType="image/png">${overlay.src}</StaticResource>
                  </NonLinear>
                </NonLinearAds>
              </Creative>
            </Creatives>
          </InLine>
        </Ad>
      </VAST>
    `;
  },

  generateVastData: (adContent, type = AdTypes.Media) => {
    switch( type) {
      case AdTypes.Media: return Advert.generateMediaVastData( adContent.media, adContent.skipTime);
      case AdTypes.Overlay: return Advert.generateOverlayVastData( adContent);
      default: return '';
    }
  },

  generateAdBreak: (adContent, timeOffset, type = AdTypes.Media) => {
    if( timeOffset !== 'start' && timeOffset !== 'end') timeOffset = Advert.secondsToHMS(timeOffset);
    return `
      <vmap:AdBreak breakType="linear" breakId="${adContent.id}" timeOffset="${timeOffset}">
        <vmap:AdSource>
          <vmap:VASTAdData>
            ${Advert.generateVastData( adContent, type)}
          </vmap:VASTAdData>
        </vmap:AdSource>
      </vmap:AdBreak>
    `;
  },

  generateVMAP: advert => {
    const preRoll = Advert.selectMatchingRoll( advert.preRolls);
    const midRolls = advert.midRolls;
    const overlays = advert.overlays;
    const postRoll = Advert.selectMatchingRoll( advert.postRolls);
    
    return `
      <vmap:VMAP xmlns:vmap="https://www.iab.com/videosuite/vmap" version="1.0">
        ${preRoll ? Advert.generateAdBreak( preRoll, 'start') : ''}
        ${midRolls ? midRolls.map( (midRoll, i) => Advert.generateAdBreak( midRoll, i*advert.secondsBetweenAds)).join('\n') : ''}
        ${overlays ? overlays.map( (overlay, i) => Advert.generateAdBreak( overlay, i*advert.secondsBetweenOverlays, AdTypes.Overlay)).join('\n') : ''}
        ${postRoll ? Advert.generateAdBreak( postRoll, 'end') : ''}
      </vmap:VMAP>
    `;
  },

};

export default Advert;
